import React, { useState, useEffect, useContext } from "react";
import { OutputContext } from "../../shared/contexts/OutputContext";
import {
  currencyFormatter,
  percentageFormatter,
} from "../../shared/utils/formatters";
import classes from "./AbatementWarning.module.css";

const AbatementWarning = () => {
  const { outputs, loading } = useContext(OutputContext);
  const [hasPositiveValues, setHasPositiveValues] = useState(false);
  const [values, setValues] = useState({});

  //console.log(values)

  useEffect(() => {
    if (!loading && outputs) {
      const abatementObject = outputs.find(
        (object) => object.benefitType === "abatement"
      );

      if (abatementObject && abatementObject.values) {
        const valuesFromObject = abatementObject.values;
        const positiveValues = Object.values(valuesFromObject).some(
          (value) => value.reduction > 0
        );
        if (positiveValues) {
          setValues(valuesFromObject);
          setHasPositiveValues(true);
        } else {
          setHasPositiveValues(false);
        }
      }
    }
  }, [loading, outputs]);

  if (loading || !hasPositiveValues) return null;

  return (
    <div className={classes.abatement_container}>
      <h3>Warning: At least one of your pension options has been reduced due to abatement!</h3>
      <p>
        You can learn more about abatement and how it is calculated on the following website: {" "}
        <a
          href="https://www.finance-ni.gov.uk/publications/what-abatement"
          target="_blank"
        >
          https://www.finance-ni.gov.uk/publications/what-abatement
        </a>
        .
      </p>
      <p><strong>Note that abatement figures are based on nominal results only and are calculated using an approximate salary of reference.</strong></p>
      <p>If you...</p>
      <ul class="no-bullets">
        {Object.entries(values).map(([year, value]) => (
          <li key={year}>
            <strong>{year}{value.reduction === 0 ? " (no abatement)" : " (abated)"}</strong>:
            {value.reduction !== 0  ? 
              <ul>
                <li>
                &gt; Your annual pension will be reduced by:{" "}
                  {currencyFormatter(value.reduction)}
                </li>
                <li>
                &gt; To prevent abatement you will need to reduce your current annual earnings
                  by: {percentageFormatter(value.equalisation_percentage)}
                </li>
              </ul> : 
              <ul>
                <li>
                &gt; Your annual pension will not be reduced.
                </li>
              </ul>}

          </li>
        ))}
      </ul>
      <p>
      Please note that the statements above provide an illustration of how you can prevent abatement by reducing your current annual earnings. Alternatively, you can prevent abatement by reducing the amount of pension taken at partial retirement. You can use the toggles below to vary how much pension is taken at partial retirement and the impact it has on abatement. 
      </p>
      <p>
      Note that commutation through the user input options (the equalising lump sums toggles below, and the commutation toggles at the bottom of this page) do not make any allowance for abatement.
      </p>
    </div>
  );
};

export default AbatementWarning;
